import { FoodsBadge } from "@foodpilot/foods";
import { Stack, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

type StrategyHeaderProps = {
    actionPlansCount?: number | null;
};
export const StrategyHeader = (props: StrategyHeaderProps) => {
    const theme = useTheme();
    const { t } = useTranslation();

    const { actionPlansCount = 0 } = props;
    const datavizColor = theme.custom.dataviz.colorsWithExtra[12];

    return (
        <Stack flexDirection={"row"} gap={theme.spacing(2)} justifyContent={"space-between"} alignItems={"center"}>
            <Stack flexDirection="row" gap={theme.spacing(1)} alignItems={"center"}>
                <FoodsBadge
                    size={5}
                    icon={"trajectory"}
                    boxProps={{
                        sx: {
                            padding: theme.spacing(1),
                            color: datavizColor.variant[700],
                            backgroundColor: datavizColor.variant[100],
                            borderRadius: "8px",
                        },
                    }}
                />
                <Typography variant="h3" alignSelf={"center"}>
                    {t("company.overview.strategy_title", "My trajectory and action plans")}
                </Typography>
                {(actionPlansCount ?? 0) >= 4 && (
                    <>
                        <Typography variant="huge" alignSelf={"center"}>
                            {"-"}
                        </Typography>
                        <Typography variant="huge" alignSelf={"center"} sx={{ transform: "translateY(0.5px)" }}>
                            {`${actionPlansCount}`}
                        </Typography>
                    </>
                )}
            </Stack>
        </Stack>
    );
};
